import React, { useState } from "react";
import Tilt from "react-parallax-tilt";
import { QRCodeSVG } from "qrcode.react";
import logo from './logo.png'
const DigitalPlatinumCard = () => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div className="card-container pt-5">
      <Tilt glareEnable={true} glareMaxOpacity={0.25} scale={1.05} tiltMaxAngleX={10} tiltMaxAngleY={10}>
        <div className={`platinum-card ${flipped ? "flipped" : ""}`}>
          {/* Front Side */}
          <div className="card-face card-front p-4">
            <h5 className="brand-title text-center mb-4 d-flex align-items-center">
       <div className="logo-circle d-flex align-items-center justify-content-center me-3 " ><img src={logo} width='50' height='auto' alt="" />  </div>      Level & Flow Industrial Automation Pvt. Ltd.
            </h5>

            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
               
                  
                
                <div>
                  <h5 className="card-name mb-1">  Sushank Kr. Verma</h5>
                  <p className="card-role mb-1">Sales & Technical Manager</p>
                  <p className="card-phone mb-0">+91 9990423266</p>
                  <p className="card-phone mb-0">+91 8448557369</p>

                </div>
              </div>
              <div className="qr-code-front">
                <QRCodeSVG
                  value={`BEGIN:VCARD
VERSION:3.0
N:  Sushank Kr. Verma
TEL:+919990423266
EMAIL:levelflowinfo@gmail.com
END:VCARD`}
                  size={80}
                  fgColor="#000000"
                />
              </div>
            </div>

            {/* <p className="address mt-4 small text-muted">
              <i className="fa fa-map-marker me-2"></i>
              Office No-306, 3rd Floor, RG Trade Tower, <br />
              Netaji Subhash Place, New Delhi - 110034
            </p> */}
          </div>

          {/* Back Side */}
          <div className="card-face card-back p-4">
            <h5 className="brand-title text-center mb-4 d-flex align-items-center">
       <div className="logo-circle d-flex align-items-center justify-content-center me-3 "><img src={logo} width='50' height='auto' alt="" />  </div>      Level & Flow Industrial Automation Pvt. Ltd.
            </h5>

            <p className="address mt-3 small text-muted">
              <div> <i className="fa fa-map-marker me-2"></i>  A-59, Naresh Park Industrial Area, New Delhi - 110041</div>
            </p>
            <div className="qr-box">
              <QRCodeSVG
                value="https://maps.app.goo.gl/K1hbU2DXvBMfrP888"
                size={60}
                fgColor="#000000"
              />
            </div>
          </div>
        </div>
      </Tilt>

      {/* Manual flip button */}
      <button
        className="platinum-btn mt-4 rounded-pill"
        onClick={() => setFlipped(!flipped)}
      >
        {flipped ? "Show Front" : "Show Back"}
      </button>

      {/* Action buttons */}
      <div className="d-flex flex-column gap-3 mt-5 w-75 mx-auto" style={{ maxWidth: "280px" }}>
        <a href="/Sushank.vcf" download className="platinum-btn">Add To Contacts</a>
        <a href="tel:9990423266" className="platinum-btn">Call Now</a>
        <a href="https://wa.me/919990423266" target="_blank" className="platinum-btn">
  WhatsApp
</a>

        <a href="mailto:levelflowinfo@gmail.com" className="platinum-btn">Email Us</a>
        <a href="https://www.levelnflow.com/" target="_blank" rel="noopener noreferrer" className="platinum-btn">Website</a>
        <a href="https://maps.app.goo.gl/K1hbU2DXvBMfrP888" target="_blank" rel="noopener noreferrer" className="platinum-btn">Visit Location</a>
        <a href="/brochure.pdf" download className="platinum-btn">Brochure</a>
      </div>
    </div>
  );
};

export default DigitalPlatinumCard;
